import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorCardProps {
  message?: string;
  onRetry?: () => void;
  title?: string;
}

/**
 * Premium Error Card for feature-level failures.
 * Adheres to "Cracked Glass" aesthetics: semi-transparent, deep red borders, and soft glows.
 */
export const ErrorCard: React.FC<ErrorCardProps> = ({ 
  message = "נתקלנו בבעיה בטעינת המידע.", 
  onRetry,
  title = "תקלה בחיבור"
}) => {
  return (
    <div className="group relative overflow-hidden rounded-2xl bg-red-500/5 backdrop-blur-md border border-red-500/20 p-6 shadow-2xl transition-all hover:bg-red-500/10 hover:border-red-500/30">
      {/* Background Decorative "Crack" Glow */}
      <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-600/10 blur-3xl rounded-full" />
      
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 p-3 rounded-full bg-red-500/10 border border-red-500/20 shadow-inner">
          <AlertTriangle className="w-8 h-8 text-red-400 animate-pulse" />
        </div>
        
        <h3 className="text-lg font-bold text-white mb-2 font-hebrew">
          {title}
        </h3>
        
        <p className="text-mystic-300 text-sm mb-6 max-w-[280px] leading-relaxed font-hebrew">
          {message}
        </p>

        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center gap-2 px-6 py-2 bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 text-red-200 text-sm font-medium rounded-xl transition-all active:scale-95 shadow-lg shadow-red-900/20"
          >
            <RefreshCw size={14} className="group-hover:rotate-180 transition-transform duration-500" />
            <span>נסה שוב</span>
          </button>
        )}
      </div>

      {/* Aesthetic Border Glows */}
      <div className="absolute inset-0 pointer-events-none border border-white/5 rounded-2xl" />
    </div>
  );
};
